export const getToursHeader = (state) =>
    state.Tours.toursHeader;

export const getParcels = (state) =>
    state.Tours.parcels;
